
import { defineComponent } from 'vue';
import AdCompareListItem from '@/ad/components/AdCompareListItem.vue';
import AdCompareShare from '@/ad/components/AdCompareShare.vue';
import { adService } from './AdService';
import config from '@/shared/constants/config';
import { urlJoin } from '@/shared/helpers/urlJoin';
import { googleTagManagerService } from '@/shared/services/GoogleTagManagerService';

export default defineComponent({
  components: {
    AdCompareListItem,
    AdCompareShare,
  },
  props: {
    mode: Number,
    estateAgencyId: Number,
    frontUserId: Number,
  },
  data() {
    return {
      isLoading: false,
      ads: null as null | [],
      isOwner: false,
      compareUrl: null as null | string,
    };
  },
  computed: {
    headerHasAddon(): boolean {
      return this.ads != null && this.ads.length > 0;
    },
  },
  async created() {
    this.isLoading = true;
    try {
      const params = {} as any;
      if (this.$route.query.adCompareId) {
        params.adCompareId = this.$route.query.adCompareId;
      }
      const result = await adService.getCompare(params);
      this.ads = result.data.ads;
      this.isOwner = result.data.isOwner;
      this.compareUrl = urlJoin(window.location.origin, config.FRONT_RELATIVE_APP_URL, '/compare?adCompareId=' + result.data.adCompareId);
      this.isLoading = false;

      googleTagManagerService.send({
        event: 'porovnanie_zobrazenie',
      });
    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    scrollLeft() {
      if (this.$refs.scrollContent) {
        (this.$refs.scrollContent as any).scrollLeft -= 361;
      }
    },
    scrollRight() {
      if (this.$refs.scrollContent) {
        (this.$refs.scrollContent as any).scrollLeft += 361;
      }
    },

    onRemoved(index: number) {
      if (this.ads) {
        this.ads.splice(index, 1);
      }
    },
  },
});
